import mediumZoom from "medium-zoom";

interface SimpleVimeoPlayer {
  pause(): Promise<void>;
  play(): Promise<void>;
  setCurrentTime(seconds: number): Promise<number>;
}

export class Home {
  private player: SimpleVimeoPlayer | undefined;
  private $popup!: HTMLDialogElement;

  private closeHandler = this.clickOutsideHandler.bind(this);

  constructor() {
    this.initImagePopups();
    this.initVideoPopup();
    this.initStepPreview();
  }

  private initImagePopups() {
    mediumZoom("[data-zoomable]", {
      background: "",
    });
  }

  private initVideoPopup() {
    this.$popup = document.querySelector<HTMLDialogElement>(
      "[data-home-video-popup]",
    )!;

    const $triggers = document.querySelectorAll(
      "[data-home-video-popup-trigger]",
    );
    const $closeTrigger = document.querySelector(
      "[data-home-video-popup-close-trigger]",
    )!;

    $triggers.forEach(($trigger) => {
      $trigger.addEventListener("click", () => {
        this.openModal();
      });
    });

    this.$popup.addEventListener("close", () => {
      this.pauseVideo();
    });

    $closeTrigger.addEventListener("click", () => {
      this.closeModal();
    });
  }

  private pauseVideo() {
    this.vimeoPlayer?.pause();
    this.vimeoPlayer?.setCurrentTime(0);
  }

  private get vimeoPlayer() {
    if (this.player) {
      return this.player;
    }

    const $iframe = document.querySelector<HTMLIFrameElement>(
      "[data-video-popup-video]",
    );

    if ($iframe) {
      // @ts-ignore
      this.player = new Vimeo.Player($iframe) as SimpleVimeoPlayer;
      return this.player;
    }
  }

  private openModal() {
    this.$popup.showModal();
    this.vimeoPlayer?.play();
    this.prepareClickOutside();
  }

  private closeModal() {
    this.pauseVideo();
    this.$popup.close();
    this.$popup.removeEventListener("click", this.closeHandler);
  }

  private prepareClickOutside() {
    this.$popup.addEventListener("click", this.closeHandler);
  }

  private clickOutsideHandler(e: MouseEvent) {
    const $target = e.target as HTMLElement;
    const rect = $target.getBoundingClientRect();
    const canClose =
      rect.left > e.clientX ||
      rect.right < e.clientX ||
      rect.top > e.clientY ||
      rect.bottom < e.clientY;

    if (canClose && this.$popup.open) {
      this.closeModal();
    }
  }

  private initStepPreview() {
    const $previewContainer = document.querySelector<HTMLElement>(
      "[data-step-preview]",
    );
    const $stepItems = document.querySelectorAll<HTMLElement>(
      "[data-step-image-trigger]",
    );

    if (!$previewContainer || $stepItems.length === 0) {
      return;
    }

    const $previewImages = $previewContainer.querySelectorAll<HTMLImageElement>(
      "img[data-step-image]",
    );

    if ($previewImages.length === 0) {
      return;
    }

    // Function to switch active image
    const switchToImage = (label: string) => {
      $previewImages.forEach(($img) => {
        const imgLabel = $img.getAttribute("data-step-image");
        if (imgLabel === label) {
          $img.classList.remove("hidden");
        } else {
          $img.classList.add("hidden");
        }
      });
    };

    // Add hover listeners to switch images
    $stepItems.forEach(($item) => {
      $item.addEventListener("mouseenter", () => {
        const label = $item.getAttribute("data-step-image-trigger");
        if (label) {
          switchToImage(label);
        }
      });
    });
  }
}
